import utils, { UTILS } from '../../utils'

var BASE_DATA_MANAGER = {
    /**
     * 根据服务器返回数据获取基础数据列表
     * @param {数据类型} type :situation,strong,medicine
     * @param {数据列表} list 
     */
    getBaseListDataByData(type, list) {
        var resultData = [];
        list.forEach(data => {
            var newData = {
                id: data.id,
                text: data.f_name,
                type: type
            }
            resultData.push(newData);
        });
        // resultData.sort((a, b) => {return a.id - b.id})
        return resultData;
    },

    /**
     * 根据id获取相关基础数据的text
     * @param {数据列表} dataList 
     * @param {id} id 
     */
    getBaseDataTextById(dataList, id) {
        var result = '';
        dataList.forEach(data => {
            if(data.id == id){
                result = data.text;
            }
        });
        return result;
    }
}

export {
    BASE_DATA_MANAGER
}